import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getDeviceId } from './browser-manager-data.reducer';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class BrowserManagerDataStore {
  deviceId$: Observable<string> = this._store.select(getDeviceId);

  constructor(private _store: Store<any>) {}

  getDeviceId(): Observable<string> {
    return this.deviceId$.pipe(
      filter((id) => !!id),
      take(1)
    );
  }
}
